"use client";

import Image from "next/image";
import Link from "next/link";

export default function About() {
  return (
    <section
      id="about"
      className="relative max-w-[1525px] w-full overflow-hidden mt-14"
    >
      {/* Background Image */}
      <Image
        src="/images/About.png"
        alt="Background Pattern"
        fill
        className="object-cover"
      />

      <div className="relative font-light z-10 px-5 sm:px-4 pt-20 pb-10 sm:pl-28">
        <h2 className="sm:text-6xl text-4xl font-medium max-w-[480px] text-center text-white mb-16">
          About Us
        </h2>

        <div className="space-y-8  max-w-[480px]">
          <p className=" text-white leading-relaxed">
            At Digital Thrive, we&apos;re a 100% Australian-owned digital studio
            built for Australian businesses—local at heart, global in ambition.
            We’re a team of curious minds, bold creatives, and strategic
            thinkers from across the country and around the world, united by a
            passion to craft digital experiences that make a difference.
            <br />
            From stunning product designs to powerful custom-built platforms, we
            blend creativity, technology, and strategy to help ambitious brands
            grow, connect, and lead in the digital space.
            <br />
            We’ve helped local startups find their voice and supported
            international brands that chose to build their digital future from
            Australia. Whether you’re a small business with big dreams or a
            large enterprise looking to stand out, we partner with you to create
            work that’s truly world-class.
          </p>

          <p className="text-white leading-relaxed">
            With a focus on top-tier quality, human-centered design, and
            emerging technologies like AI, we don’t just build—we thrive.
          </p>
        </div>

        <div className="mt-32 text-[15px] flex sm:flex-row flex-col sm:items-end justify-between w-full text-[#B1B1B1]">
          <section>
            <p>© 2025 Digital Thrive. All Rights Reserved.</p>
            <p>Crafted With Creativity, Built With Purpose.</p>
          </section>
          <section>
            <ul className="flex mt-2 sm:mt-0 text-primary text-[16px] font-medium space-x-2 sm:space-x-4 whitespace-nowrap">
              <li>
                <Link href="/terms-of-use">Terms of Use</Link>
              </li>
              <li>|</li>
              <li>
                <Link href="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>|</li>
              <li>
                <Link href="/cookies-policy">Cookies Policy</Link>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </section>
  );
}
